import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type SecurityDashboard } from '../../api/security';

const NAV = [
  { to: '/security', label: 'SOC Hub' },
  { to: '/security/threats', label: 'Threat Center' },
  { to: '/security/incidents', label: 'Incident Center' },
  { to: '/security/identity', label: 'Identity Governance' },
  { to: '/security/risk', label: 'Risk Center' },
  { to: '/security/compliance', label: 'Compliance Center' },
  { to: '/security/audit', label: 'Audit Explorer' },
  { to: '/security/secrets', label: 'Secrets Vault' },
  { to: '/security/policies', label: 'Policy Manager' },
  { to: '/security/investigation', label: 'Investigation Console' },
];

export function SecurityHubPage() {
  const [dash, setDash] = useState<SecurityDashboard | null>(null);
  useEffect(() => { void securityApi.dashboard().then(setDash); }, []);
  const stats = dash ? [
    { label: 'Security Health', value: dash.security_health },
    { label: 'Open Incidents', value: dash.open_incidents },
    { label: 'Critical Incidents', value: dash.critical_incidents },
    { label: 'Blocked Threats', value: dash.blocked_events },
    { label: 'Avg Risk Score', value: dash.average_risk_score.toFixed(0) },
    { label: 'Compliance Score', value: `${dash.compliance_score.toFixed(0)}%` },
    { label: 'Pending Reviews', value: dash.pending_reviews },
    { label: 'Zero Trust', value: dash.zero_trust_enabled ? 'Enabled' : 'Disabled' },
  ] : [];
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Enterprise Security Operations Center</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Zero Trust security, identity governance, threat detection and compliance.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">{NAV.map((l) => <Link key={l.to} to={l.to} className="text-indigo-700 hover:underline dark:text-indigo-400">{l.label}</Link>)}</nav>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">{stats.map((s) => (
        <div key={s.label} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900"><p className="text-sm text-slate-500">{s.label}</p><p className="mt-1 text-xl font-semibold">{String(s.value)}</p></div>
      ))}</div>
    </div>
  );
}
